import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    name: {
      id: 'properties.name',
      defaultMessage: 'Name',
      description: 'Label of the name field in the channel form',
    },
    description: {
      id: 'properties.description',
      defaultMessage: 'Description',
      description: 'Label of the description field in the channel form',
    },
    type: {
      id: 'properties.type',
      defaultMessage: 'Type',
      description: 'Label of the type field in the channel form',
    },
    client: {
      id: 'properties.client',
      defaultMessage: 'Client',
      description: 'Label of the client field in the channel form',
    },
  },
  types: {
    pos: {
      id: 'channelTypes.pos',
      defaultMessage: 'POS',
      description: 'Label of the channel type pos',
    },
    storefront: {
      id: 'channelTypes.storefront',
      defaultMessage: 'Storefront',
      description: 'Label of the channel type storefront',
    },
    order: {
      id: 'channelTypes.order',
      defaultMessage: 'Order',
      description: 'Label of the channel type order',
    },
    integration: {
      id: 'channelTypes.integration',
      defaultMessage: 'Integration',
      description: 'Label of the channel type integration',
    },
  },
};

export default defineMessages(translations);
